import type { ComputedRef, MaybeRefOrGetter, Ref } from 'vue'
import type { AutologinFormData } from './types/student-app/interfaces'

import { trackEvent } from '@shared/lib/amplitude'
import { flushBeforeLeave } from '@shared/lib/amplitude'

import { getStudentAppAutologin } from '../lib/autologin'

interface LinkStudentAppOptions {
  redirect?: MaybeRefOrGetter<string | null>
}

interface LinkStudentAppReturn {
  text: string
  formRef: Ref<HTMLFormElement | null>
  formData: ComputedRef<AutologinFormData | null>
  handleClick: () => void
}

export const useLinkStudentApp = (options: LinkStudentAppOptions = {}): LinkStudentAppReturn => {

  const text = 'Practice'

  const formRef = ref<HTMLFormElement | null>(null)

  // POST the signature to avoid flagging Student app as Dangerous on some browsers (e.g. Chrome).
  const formData = computed<AutologinFormData | null>(() => getStudentAppAutologin(toValue(options.redirect) ?? null))

  const handleClick = (): void => {
    // The signature travels in its own field, so the action URL carries no token.
    trackEvent('Link_click', { feature: 'navigation', name: 'student_app', text, url: formData.value?.action ?? null })

    // The DS MenuButton is a type="button" button: submit the form once the click is tracked.
    flushBeforeLeave()
    formRef.value?.submit()
  }

  return {
    text,
    formRef,
    formData,
    handleClick,
  }
}
